import {GeoCoordinate} from "@renta-apps/athenaeum-toolkit";

export default class SignInRequest {

    public constructionSiteOrWarehouseId: string = "";

    public workOrderId: string | null = null;

    public location: GeoCoordinate | null = null;
}